import {
  IntegrationKind,
  IntegrationSource,
} from "@redotech/redo-integrations-core";
import { createEnum } from "@redotech/zod-util/zod-enum";
import * as z from "zod/v4";

export const connectToIntegration = {
  name: "connectToIntegration" as const,
  input: z.object({
    integrationId: createEnum(IntegrationKind),
    connectionId: z.string(),
    inputValues: z.record(z.string(), z.any()).optional(),
    source: createEnum(IntegrationSource).optional(),
  }),
  output: z.object({
    success: z.boolean(),
    redirectUrl: z.string().optional(),
    message: z.string().optional(),
  }),
};
